// extracted by mini-css-extract-plugin
module.exports = {"ulist":"default_ulist__vAeFn","olist":"default_olist__l8XMI","table":"default_table__pATLL","pre":"default_pre__ZsUs2","code":"default_code__ImPrQ"};